<div class="dialog-content">
    <div class="dialog-header d-flex justify-content-beetween">
        <h4
            mat-dialog-title
            class="dialog-title w-100 text-start p-3 pe-5">
            <i class="fas fa-exclamation-triangle text-red me-2 fs_20"></i>
            {{ data.title }}
        </h4>
        <button
            class="btn--text-only close-icon"
            (click)="close(true)">
            <i class="far fa-times-circle"></i>
        </button>
    </div>

    <div
        mat-dialog-content
        class="text-center ps-3 pe-3">
        <p class="step-form__title text-start p-3 grey-bg">
            {{ data.message }}
        </p>
    </div>

    <div
        mat-dialog-actions
        class="dialog-footer p-2 gap-2 d-flex justify-content-center">
        <button
            type="button"
            class="btn btn--text-only mt-0"
            (click)="close(true)">
            {{ data.confirmText }}
        </button>
        <button
            type="button"
            class="btn btn--ghost-red mt-0"
            cdkFocusInitial
            (click)="close(false)">
            {{ data.cancelText }}
        </button>
    </div>
</div>
